export enum EAppcuesEvent {
  EXPERIENCE_DISMISSED = 'Experience Dismissed',
  EXPERIENCE_STARTED = 'Experience Started',
  STEP_SEEN = 'Step Seen',
}
